import { Button } from '@material-ui/core';
import { makeStyles } from '@material-ui/core/styles';
import CloudDownloadIcon from '@material-ui/icons/CloudDownload';
import React, { useEffect, useState } from 'react';
import { useFieldArray, useForm } from "react-hook-form";
import { useDispatch, useSelector } from 'react-redux';
import { withRouter } from 'react-router-dom';
import { downloadRoadXmlFilesStart, fetchRoadXmlFilesStart } from 'redux/actions/xmlFile.action';
import EditorModal from './EditorsModal';
import styles from './RoadCondition.module.scss';

const useStyles = makeStyles({
    root: {
        flexGrow: 1,
    },
    button: {
        textTransform: "none",
        color: '#0fc5d3',
        border: '1px solid #0fc5d3'
    },
    rowMargin: {
        margin: '3%'
    },
});

const XmlEditor = props => {
    const classes = useStyles();
    const dispatch = useDispatch();
    const { register, control, reset, formState } = useForm();
    useEffect(() => { dispatch(fetchRoadXmlFilesStart()) }, []);
    const roadConditionState = useSelector((state) => state.roadXmlFiles);
    
    useEffect(() => {
        if (roadConditionState.roadXmlFiles && roadConditionState.roadXmlFiles.files) {
            reset(roadConditionState.roadXmlFiles);
            //setValue("roadConditions", roadConditionState.roadConditions.roadConditions);
        }
    }, [roadConditionState.roadXmlFiles?.files, fields]);

    useEffect(() => {
        if (roadConditionState && roadConditionState.isSaved && nextTabIndex !== 2) {
            props.successToast("Successfully saved special events")
        }
    }, [roadConditionState.isSaved]);
    useEffect(() => {
        if (roadConditionState && roadConditionState.error) {
            props.errorToast(roadConditionState.error)
        }
    }, [roadConditionState.error]);
    const { fields } = useFieldArray(
        {
            control,
            name: "files"
        }
    );
    const [isDirty, setIsDirty] = useState(false);
    useEffect(() => {
        const { isDirty } = formState;
        setIsDirty(isDirty);
        if (!isDirty) {
            props.handleChange(nextTabIndex);
        }
    }, [formState, props.nextTabIndex])
    const onDiscard = () => {
        props.handleChange(nextTabIndex);
        reset(roadConditionState.roadXmlFiles);
        setShowModal(false);

    }
    const onSave = () => {
        props.handleChange(nextTabIndex);
        setShowModal(false)
    }
    const onHide = () => {
        props.handleChange(2);
        setShowModal(false)
    }
    const downloadXmlFile = (file) => {
        dispatch(downloadRoadXmlFilesStart({ "roadXmlFiles": file.fileId, "fileName": file.fileName,"actionType":'download' }));
    }
    const openXmlFile = (file) => {
        dispatch(downloadRoadXmlFilesStart({ "roadXmlFiles": file.fileId, "fileName": file.fileName,"actionType":'openInNewTab' }));
    }
    const [showModal, setShowModal] = useState(true);
    const [nextTabIndex, setNextTabIndex] = useState(props.nextTabIndex);
    useEffect(() => { setNextTabIndex(props.nextTabIndex); setShowModal(true) }, [props.nextTabIndex]);
    return (
        <div>
            {nextTabIndex !== 2 && showModal && isDirty ?
                <EditorModal
                    onSave={onSave}
                    onDiscard={onDiscard}
                    onHide={onHide}
                    show={showModal}
                    modalBody="Do you want to save Road Xml Files and Continue?" /> :
                <>
                    <form >
                        {/* <div className={styles.margin3}>
                            <h3>Road Conditions XML file</h3>
                            <div className={styles.mr2 + " ml-auto"}>
                                <span className={styles.fontSize}>last updated:- 14-05-2018 12:51</span>
                            </div>
                            <div >
                                <Button variant="outlined" className={styles.xmlButton}>roadConditions.xml</Button>
                            </div>

                        </div> */}
                        <div className={styles.rowEnd}></div>
                        <div className={styles.margin3}>
                            <h3 className={styles.mb2}>Most Recent 20 XML Files</h3>
                            {
                                fields.map((file, index) => (
                                    <div key={index}>
                                        <div className={styles.xmlBackupRow}>
                                            <div className='row'>
                                                <div className='col'>
                                                <Button title="View XML File" onClick={() => openXmlFile(file)}> {(index + 1) + "." + file.fileName}</Button>
                                                <Button title="Download XML File" onClick={() => downloadXmlFile(file)}>
                                                     <span className={styles.pl1}><CloudDownloadIcon style={{fontSize: "28px", color: "#002664",marginLeft: "20px"}}/></span></Button>
                                                </div></div>
                                            <div className={styles.mr2 + " ml-auto "+styles.pl26}>
                                                <span className={styles.fontSize}>Backup Date: {file.receivedTimeStamp ? file.receivedTimeStamp.replace('T', ' ').substring(0, 16) : ''}</span>
                                            </div>
                                        </div>
                                    </div>))
                            }
                        </div>

                    </form>
                </>}
        </div>
    );
}

export default withRouter(props => <XmlEditor {...props} />);